import {
    ADD_MESSAGES,
    SET_MESSAGES,
//    SET_USERS_COUNT,
//    SET_CURRENT_USER,
    SET_CONNECTION_ESTABLISHED,
    SET_CONNECTION_ID,
    UPDATE_QUESTIONS
} from './actionTypes.js';

const addMessages = payload => {
    return {
        type: ADD_MESSAGES,
        payload
    };
};

const setMessages = payload => {
    return {
        type: SET_MESSAGES,
        payload
    };
};

const updateQuestions = payload => {
    return {
        type: UPDATE_QUESTIONS,
        payload
    };
};

// const setUsersCount = payload => {
//     return {
//         type: SET_USERS_COUNT,
//         payload
//     };
// };

// const setCurrentUser = payload => {
//     return {
//         type: SET_CURRENT_USER,
//         payload
//     };
// };

const setConnectionEstablished = payload => {
    return {
        type: SET_CONNECTION_ESTABLISHED,
        payload
    };
};

const setConnectionId = payload => {
    return {
        type: SET_CONNECTION_ID,
        payload
    };
};

export default () => ({
    addMessages,
    setMessages,
//    setUsersCount,
//    setCurrentUser,
    setConnectionEstablished,
    setConnectionId,
    updateQuestions
});
